import type * as React from 'react';
import { Toaster as Sonner } from 'sonner';

import { useTheme } from '@/providers';

type ToasterProps = React.ComponentProps<typeof Sonner>;

function Toaster({ ...props }: ToasterProps): React.ReactElement {
  const { resolvedTheme } = useTheme();

  return (
    <Sonner
      className="toaster group"
      position="bottom-right"
      theme={resolvedTheme}
      gap={10}
      offset={16}
      visibleToasts={4}
      toastOptions={{
        style: {
          alignItems: 'flex-start',
          fontFamily: 'inherit',
          gap: '10px',
          padding: '12px 14px',
        },
        classNames: {
          toast:
            'group toast group-[.toaster]:min-h-0 group-[.toaster]:w-[356px] group-[.toaster]:max-w-[calc(100vw-2rem)] group-[.toaster]:rounded-xl group-[.toaster]:border group-[.toaster]:border-border/80 group-[.toaster]:bg-popover/96 group-[.toaster]:text-popover-foreground group-[.toaster]:shadow-[0_18px_40px_-24px_rgba(15,23,42,0.45)] group-[.toaster]:backdrop-blur-xl dark:group-[.toaster]:border-white/10 dark:group-[.toaster]:bg-popover/92 dark:group-[.toaster]:shadow-[0_18px_44px_-24px_rgba(0,0,0,0.75)]',
          icon: 'group-[.toast]:mt-0.5 group-[.toast]:size-4 group-[.toast]:shrink-0 group-[.toast]:text-muted-foreground',
          content: 'group-[.toast]:min-w-0 group-[.toast]:flex-1',
          title:
            'group-[.toast]:min-w-0 group-[.toast]:font-medium group-[.toast]:text-[13px] group-[.toast]:text-foreground group-[.toast]:leading-snug',
          description:
            'group-[.toast]:mt-1 group-[.toast]:text-[12px] group-[.toast]:text-muted-foreground group-[.toast]:leading-relaxed',
          actionButton:
            'group-[.toast]:h-7 group-[.toast]:rounded-md group-[.toast]:bg-primary group-[.toast]:px-2.5 group-[.toast]:font-medium group-[.toast]:text-[12px] group-[.toast]:text-primary-foreground hover:group-[.toast]:bg-primary/90',
          cancelButton:
            'group-[.toast]:h-7 group-[.toast]:rounded-md group-[.toast]:bg-muted group-[.toast]:px-2.5 group-[.toast]:font-medium group-[.toast]:text-[12px] group-[.toast]:text-muted-foreground hover:group-[.toast]:bg-muted/80',
          closeButton:
            'group-[.toast]:border-border group-[.toast]:bg-background group-[.toast]:text-muted-foreground hover:group-[.toast]:text-foreground',
          error: '[&_[data-icon]]:!text-destructive',
          success: '[&_[data-icon]]:!text-uigreen',
          warning: '[&_[data-icon]]:!text-uiamber',
          info: '[&_[data-icon]]:!text-sky-600 dark:[&_[data-icon]]:!text-sky-400',
        },
      }}
      {...props}
    />
  );
}

export { Toaster };
